// @ts-nocheck
import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useRisingEdgeEffect } from 'src/clientLib/hooks'
import { AsyncTask } from 'src/redux/slices/async-processing/consts'
import { startAsyncTask } from 'src/redux/slices/async-processing/reducers'
import { useNavigationEffect } from 'src/redux/slices/navigation/hooks'
import { getProject } from 'src/redux/slices/project/endpoints'
import { getUmiFile } from 'src/redux/slices/umibuilder/endpoints'
import {
  isLoading,
  selectContextLayers,
  selectSummaryData,
  selectUmiBuilderFromCloud,
  selectUmiReady
} from 'src/redux/slices/umibuilder/selectors'

import Button from '@material-ui/core/Button'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import { DataGrid } from '@mui/x-data-grid'

///// API Hooks

///// DataGrid Config
const columns = [
  {
    field: 'ArchetypeID',
    headerName: 'Archetype ID',
    flex: 1,
    isEditable: false,
  },
  {
    field: 'EnergySimulatorName',
    headerName: 'Simulator',
    flex: 1,
    isEditable: false,
  },
  {
    field: 'Height',
    headerName: 'Height',
    flex: 1,
    isEditable: false,
  },
  {
    field: 'TemplateName',
    headerName: 'Template',
    flex: 1,
    isEditable: false,
  },
  {
    field: 'WindowToWallRatioN',
    headerName: 'WWR',
    flex: 1,
    isEditable: false,
  },
]

///// Component
const ExportPage: React.FC = () => {
  const dispatch = useDispatch()

  const fromCloud = useSelector(selectUmiBuilderFromCloud)
  const { data: project } = getProject.useQuery('')
  const contextLayers = useSelector(selectContextLayers)
  const { config, stats } = useSelector(selectSummaryData) ?? { config: [], stats: {} }
  const loading = useSelector(isLoading)
  const umiReady = useSelector(selectUmiReady)

  const [trigger] = getUmiFile.useLazyQuery()

  useRisingEdgeEffect({ callback: trigger, condition: umiReady })

  useNavigationEffect({ condition: umiReady && fromCloud, destination: '../project/dashboard' })

  const startUmiExport = useCallback(() => {
    const body = {
      ...contextLayers,
      projectId: project?.id,
      fromCloud,
    }
    dispatch(startAsyncTask({ endpoint: AsyncTask.startUmiExport, body }))
  }, [dispatch, fromCloud, project, contextLayers])

  return (
    <>
      <div
        style={{ display: 'flex', flexDirection: 'column', height: '100%', marginBottom: '2rem' }}
      >
        <Button disabled={loading} variant='contained' color='primary' onClick={startUmiExport}>
          Build & Export UBEM
        </Button>
        <div style={{ flexGrow: 1 }}>
          <DataGrid rows={config} columns={columns} pageSize={10} autoHeight density='compact' />
        </div>
      </div>
      <Grid container item justifyContent='center' alignItems='center' direction='row' spacing={2}>
        {Object.entries(stats).map(([stat, value], i) => (
          <Grid item key={`stat-display-${stat}-${i}`}>
            <Card variant='outlined'>
              <CardContent>
                <Typography color='textSecondary' variant='overline'>
                  {stat}:{' '}
                </Typography>
                <Typography color='primary' variant='overline'>
                  {value}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </>
  )
}

export default ExportPage
